import { render, staticRenderFns } from "./edit-inspection.vue?vue&type=template&id=6faa1d5a&scoped=true&"
import script from "./edit-inspection.vue?vue&type=script&lang=js&"
export * from "./edit-inspection.vue?vue&type=script&lang=js&"
import style0 from "./edit-inspection.vue?vue&type=style&index=0&id=6faa1d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa1d5a",
  null
  
)

export default component.exports